import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import Stepper from '@libComponents/Stepper';
//import { Stepper } from '@formComponents/Stepper';
import { useLocation } from 'react-router';
import { FORM_NAME } from './common';
import EmployeeContainer from './EmployeeContainer';
import { useContent } from './hooks';
import { theme } from 'app/Theme';
import { ContentContainer } from '@libComponents/ContentContainer';

const propTypes = {
    mode: PropTypes.oneOf(['new', 'update']),
};
const defaultProps = {
    mode: 'new',
};

/**
 * ReduxForm stepper rules
 * * Connect each step with reduxForm() to the same form name.
 * * Specify the destroyOnUnmount: false flag to preserve form data across form component unmounts.
 *
 * The wizard is reusable via optional props (all default to the standard
 * employee create/edit behaviour, so existing usage is unchanged):
 *   - title             ContentContainer heading
 *   - publish           final-submit handler ({mode, handleComplete, ...})
 *   - publishPartial    per-"Next" handler (employee update auto-saves; others
 *                       can just advance)
 *   - fetchInitial      (setValues) => void — custom prefill instead of the
 *                       default getEmployee lookup
 *   - CompleteComponent last "Complete" step component
 *   - hideSaveAndExit   hide the "Save And Exit" button
 */

const Employee = reduxForm({
    form: FORM_NAME, // Form name
    destroyOnUnmount: false, // Preserve data
    onSubmit: (v) => v,
})(({
    mode,
    handleSubmit: handleReduxFormSubmit,
    title = 'Employee Information',
    publish,
    publishPartial,
    fetchInitial,
    CompleteComponent,
    hideSaveAndExit = false
}) => {
    const { state } = useLocation();
    return (
        <ContentContainer title={title} headerBg={theme.palette.background.mainHeader}>
            <Stepper
                content={useContent(mode, CompleteComponent)}
                ContainerComponent={EmployeeContainer}
                ContainerProps={{
                    mode,
                    handleReduxFormSubmit,
                    publish,
                    publishPartial,
                    fetchInitial,
                    hideSaveAndExit,
                    ...state
                }}
            />
        </ContentContainer>
    );
});

Employee.propTypes = propTypes;
Employee.defaultProps = defaultProps;

export { Employee as default, Employee };
